  (function () {
    if (window.__productSizeSelectionInit) return;
    window.__productSizeSelectionInit = true;
  
    function initProductSizeSelection() {
      const sizeOptionsContainers = document.querySelectorAll('.size-options');
  
      sizeOptionsContainers.forEach(function (ul) {
        const newUl = ul.cloneNode(true);
        ul.parentNode.replaceChild(newUl, ul);
  
        const productId = newUl.getAttribute('data-product-id');
  
        if (!productId) {
          console.warn('No product ID found for size options container');
          return;
        }
  
        const atcBtn = document.querySelector(`#atc-btn-${productId}`);
        const atcText = document.querySelector(`#atc-text-${productId}`);
  
        if (!atcBtn || !atcText) {
          console.warn(`Missing ATC elements for product ${productId}`);
          return;
        }
  
        const initiallySelected = newUl.querySelector('li.size-option.selected');
        if (initiallySelected) {
          const variantId = initiallySelected.getAttribute('data-variant-id');
          const available = initiallySelected.getAttribute('data-available') === 'true';
          atcBtn.setAttribute('data-variant-id', variantId);
          if (!available) updateAtcButtonToSoldOut(atcBtn, atcText);
        } else {
          const firstAvailable = newUl.querySelector("li.size-option[data-available='true']");
          if (firstAvailable) {
            firstAvailable.classList.add('selected');
            atcBtn.setAttribute('data-variant-id', firstAvailable.getAttribute('data-variant-id'));
          }
        }
  
        newUl.addEventListener('click', function (e) {
          const sizeOption = e.target.closest('li.size-option');
          if (!sizeOption) return;
  
          const variantId = sizeOption.getAttribute('data-variant-id');
          const available = sizeOption.getAttribute('data-available') === 'true';
  
          newUl.querySelectorAll('li.size-option').forEach((li) => li.classList.remove('selected'));
          sizeOption.classList.add('selected');
          atcBtn.setAttribute('data-variant-id', variantId);
  
          if (available) {
            atcBtn.classList.remove('disable', 'disabled');
            atcBtn.removeAttribute('disabled');
            atcText.innerHTML = window.__atcTemplates.available;
          } else {
            updateAtcButtonToSoldOut(atcBtn, atcText);
          }
        });
      });
    }
  
    function updateAtcButtonToSoldOut(button, textElement) {
      button.classList.add('disable');
      button.setAttribute('disabled', 'true');
      textElement.innerHTML = window.__atcTemplates.soldOut;
    }
  
    function debounce(func, wait) {
      let timeout;
      return function (...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => func(...args), wait);
      };
    }
  
    const debouncedInit = debounce(initProductSizeSelection, 300);
  
    document.addEventListener('DOMContentLoaded', initProductSizeSelection);
    document.addEventListener('ajaxComplete', debouncedInit);
    document.addEventListener('fetch-complete', debouncedInit);
    document.addEventListener('products-loaded', debouncedInit);
    document.addEventListener('shopify:section:load', debouncedInit);
    document.addEventListener('shopify:block:select', debouncedInit);
  
    const observer = new MutationObserver(function (mutations) {
      const shouldReinit = mutations.some(function (mutation) {
        if (mutation.type !== 'childList' || !mutation.addedNodes.length) return false;
        return Array.from(mutation.addedNodes).some((node) => {
          if (node.nodeType !== Node.ELEMENT_NODE) return false;
          return (
            node.querySelector &&
            (node.querySelector('.size-options') ||
              node.classList?.contains('size-options') ||
              node.querySelector('.product') ||
              node.classList?.contains('product'))
          );
        });
      });
  
      if (shouldReinit) debouncedInit();
    });
  
    setTimeout(() => observer.observe(document.body, { childList: true, subtree: true }), 1000);
  
    window.reinitProductSelection = initProductSizeSelection;
  
    window.debugProductSelection = function () {
      document.querySelectorAll('.size-options').forEach((container, i) => {
        const productId = container.getAttribute('data-product-id');
        console.log(`Container ${i}: Product ID = ${productId}`);
        console.log(`  - Size options: ${container.querySelectorAll('li.size-option').length}`);
        console.log(`  - Selected: ${container.querySelectorAll('li.size-option.selected').length}`);
      });
    };
  })();